import { fetchWithToken } from "../utils/fetchWithToken";

/**
 * Voyant « connecté / déconnecté » des box (DATA `GET /devices/connection`, qui lit via VM_VPN
 * les fichiers status d'OpenVPN). `unknown` = VPN injoignable ou produit impossible à
 * reconnaître : on ne conclut pas à une déconnexion.
 */
export type ConnectionStatus = "connected" | "disconnected" | "unknown";

export type DeviceConnection = {
  uuid: string;
  status: ConnectionStatus;
  ip?: string;
  connected_since?: string;
};

// OpenVPN ne réécrit ses fichiers status que toutes les 60 s, et le tableau de bord affiche un
// widget par régulateur : une seule requête par page, réutilisée 30 s.
const CACHE_MS = 30_000;
let cache: {
  at: number;
  promise: Promise<Record<string, DeviceConnection>>;
} | null = null;

/** État de connexion des produits visibles, indexé par uuid. En cas d'échec : `{}` (tout inconnu). */
export const fetchDeviceConnections = (): Promise<
  Record<string, DeviceConnection>
> => {
  if (cache && Date.now() - cache.at < CACHE_MS) return cache.promise;
  const promise = (async () => {
    try {
      const response = await fetchWithToken(
        `${process.env.REACT_APP_URL_SERVER_DATA}/devices/connection`,
        { method: "GET", headers: { "Content-type": "application/json" } }
      );
      if (response.status !== 200) return {};
      const list: DeviceConnection[] | null = await response.json();
      return Object.fromEntries((list ?? []).map((c) => [c.uuid, c]));
    } catch (err) {
      console.error("Erreur:", err);
      return {};
    }
  })();
  cache = { at: Date.now(), promise };
  return promise;
};

/** Pour les tests : oublie la dernière réponse. */
export const resetDeviceConnectionsCache = () => {
  cache = null;
};
